const youtubeBlocks = document.querySelectorAll('[data-videos="youtube"]');

if (youtubeBlocks) {
  youtubeBlocks.forEach((block) => {
    block.addEventListener("click", (event) => {
      event.preventDefault();
      const img = block.querySelector('[data-img="video"]');
      const btn = block.querySelector('[data-btn="video"]');
      const src = block.dataset.src;
      const title = block.dataset.title;

      const videoIdRegex = /\/embed\/([a-zA-Z0-9_-]+)/;
      const match = src.match(videoIdRegex);

      createIframe(block, img, src, title, btn);

      if (match) {
        const videoId = match[1];
        autoplayVideo(block, videoId);
      }
    });
  });
}

function createIframe(block, img, src, title, btn) {
  const iframe = document.createElement("iframe");
  iframe.src = `${src}?autoplay=1`;
  iframe.width = "100%";
  iframe.height = "315";
  iframe.title = title;
  iframe.frameBorder = "0";
  iframe.allowFullscreen = true;
  img.classList.add("hide");
  btn.classList.add("hide");
  block.insertAdjacentElement("beforeend", iframe);
}

let player;

function autoplayVideo(block, id) {
  player = new YT.Player(block, {
    videoId: id,
    events: {
      onReady: function (event) {
        event.target.playVideo();
        loadAndPlayVideo();
      },
    },
  });
}

function loadAndPlayVideo() {
  if (player) {
    player.playVideo();
  }
}
